import {lazy} from "react";
import LoadCategoriesWrapper from "./preloads/LoadCategoriesWrapper";
const CmsCategories = lazy(() => import("./views/cmsCategories/CmsCategories"));
const ShopCategories = lazy(() => import("./widgets/ShopCategories"));
const CategoriesCarousel = lazy(() => import("./widgets/CategoriesCarousel"));
const CmsCategoriesDrawer = lazy(() => import("./widgets/CmsCategoriesDrawer"));
const CmsProductCategories = lazy(() => import("./widgets/cmsProductCategories/CmsProductCategories"));


const exports = {
    routes: [
        {
            name: "cmsCategories",
            trans: ["Kategorije", "Categories"],
            path: ["kategorije", "categories"],
            element: <CmsCategories />,
            layouts: ["cms.CmsLayout"],
            parent: "products.cmsProductsTab",
            menus: {cmsLeft: {position: 2}},
        },
    ],
    preloads: [LoadCategoriesWrapper],
    widgets: {
        CategoriesCarousel: CategoriesCarousel,
        CmsCategoriesDrawer: CmsCategoriesDrawer,
        CmsProductCategories: CmsProductCategories,
        ShopCategories: ShopCategories,
    },
}
export default exports;
